import callAPI from '../../helpers/callAPI'

export const yesNo = (value) => {
    if (value === 'Y') {
        return 'Yes'
    } else {
        return 'No'
    }
}

export function debounce(func, wait, immediate) {
    let timeout

    return function () {
        let context = this,
            args = arguments

        let later = function () {
            timeout = null
            if (!immediate) func.apply(context, args)
        }

        let callNow = immediate && !timeout
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)

        if (callNow) func.apply(context, args)
    }
}

export function clearLocalStorageAndReload() {
    localStorage.removeItem('mb-aid')
    localStorage.removeItem('mb-auth-token')
    sessionStorage.removeItem('mb-otp-enabled') // If this is not removed then upon automatic logout, user will be redirected to otp input screen instead of email/password screen.

    window.location.reload()
}

export async function verifyToken() {
    let result = await callAPI('application/verifyToken', 'GET')

    return result.then((result) => {
        if (result['success'] === false) {
            if (result.code === 401) {
                return false
            } else {
                return false
            }
        }
        return true
    })
}
